import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { UserIsLoggedInGuard } from './feature/user/guards/user.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./feature/feature.module').then((m) => m.FeatureModule),
  },
  {
    path: 'basket',
    canActivate: [UserIsLoggedInGuard],
    loadChildren: () =>
      import('./feature/basket/basket.module').then((m) => m.BasketModule),
  },
  { path: 'about-us', redirectTo: 'contact-us' },
  { path: 'contact-us', component: ContactUsComponent },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
